// ═══════════════════════════════════════════════════════════════
//  EPJ App Globale — Système de permissions à 3 COUCHES
//  1. FACTORY (DEFAULT_PERMISSIONS, code, jamais perdu)
//  2. OVERRIDE DE RÔLE (Firestore : rolesConfig/{role})
//  3. OVERRIDE UTILISATEUR (user.permissionsOverride)
// ═══════════════════════════════════════════════════════════════

export const ROLES = [
  "Admin", "Direction", "Conducteur travaux", "Assistante", "Achat",
  "Chef chantier", "Monteur", "Artisan", "Étude",
];

export const MODULES = [
  "commandes", "parc-machines", "avancement",
  "reserves-quitus",
  "gestionChantier",
  "gestionChantier.pieuvres", "gestionChantier.commandes", "gestionChantier.financier",
  "gestionChantier.suivi", "gestionChantier.gantt", "gestionChantier.tma",
  "gestionChantier.demarches",
  "gestionChantier.planning",
  // ─── Module RH (socle posé en L8 ; sous-clés conges/frais/analyse = scaffold
  //     pour ne pas re-toucher le trio aux lots RH suivants) ───
  "rh",
  "rh.planning", "rh.conges", "rh.frais", "rh.analyse",
];

export const DASHBOARDS = ["direction", "conducteur", "public"];
export const ACTIONS    = ["view", "create", "edit", "delete", "validate", "export"];

export const MODULE_LABELS = {
  commandes: "Commandes",
  "parc-machines": "Parc machines",
  avancement: "Avancement chantier",
  "reserves-quitus": "Réserves & quitus",
  gestionChantier: "Gestion de chantier",
  "gestionChantier.pieuvres":  "Gestion chantier · Pieuvres",
  "gestionChantier.commandes": "Gestion chantier · Suivi commandes",
  "gestionChantier.financier": "Gestion chantier · Suivi financier",
  "gestionChantier.suivi":     "Gestion chantier · Suivi de chantier",
  "gestionChantier.gantt":     "Gestion chantier · Planning / Gantt",
  "gestionChantier.tma":       "Gestion chantier · TMA",
  "gestionChantier.demarches": "Gestion chantier · Démarches admin",
  "gestionChantier.planning":  "Gestion chantier · Planning ressources",
  rh:            "RH",
  "rh.planning": "RH · Planning ressources",
  "rh.conges":   "RH · Congés / absences",
  "rh.frais":    "RH · Notes de frais",
  "rh.analyse":  "RH · Analyse / reporting",
};

export const ACTION_LABELS = {
  view: "Voir", create: "Créer", edit: "Modifier",
  delete: "Supprimer", validate: "Valider", export: "Exporter",
};

export const SCOPE_LABELS = {
  all: "Tout", own_chantiers: "Mes chantiers", own_items: "Mes éléments",
};

// ─── FACTORY (valeurs usine) ────────────────────────────────────
export const DEFAULT_PERMISSIONS = {
  Admin: {
    commandes:         { _access:"all", view:"all", create:"all", edit:"all", delete:"all", validate:"all", export:"all" },
    "parc-machines":   { _access:"all", view:"all", create:"all", edit:"all", delete:"all", export:"all" },
    avancement:        { _access:"all", view:"all", create:"all", edit:"all", delete:"all", validate:"all", export:"all" },
    "reserves-quitus": { _access:"all", view:"all", create:"all", edit:"all", delete:"all", validate:"all", export:"all" },
    gestionChantier:             { _access:"all", view:"all", create:"all", edit:"all", delete:"all", validate:"all", export:"all" },
    "gestionChantier.pieuvres":  { _access:"all", view:"all" },
    "gestionChantier.commandes": { _access:"all", view:"all" },
    "gestionChantier.financier": { _access:"all", view:"all" },
    "gestionChantier.suivi":     { _access:"all", view:"all" },
    "gestionChantier.gantt":     { _access:"all", view:"all" },
    "gestionChantier.tma":       { _access:"all", view:"all" },
    "gestionChantier.demarches": { _access:"all", view:"all" },
    "gestionChantier.planning":  { _access:"all", view:"all" },
    rh:            { _access:"all", view:"all", create:"all", edit:"all", delete:"all", validate:"all", export:"all" },
    "rh.planning": { _access:"all", view:"all" },
    "rh.conges":   { _access:"all", view:"all" },
    "rh.frais":    { _access:"all", view:"all" },
    "rh.analyse":  { _access:"all", view:"all" },
    _dashboards: { direction:true, conducteur:true, public:true },
    _admin: true,
  },
  Direction: {
    commandes:         { _access:"all", view:"all", create:"all", edit:"all", delete:false, validate:"all", export:"all" },
    "parc-machines":   { _access:"all", view:"all", create:"all", edit:"all", delete:false, export:"all" },
    avancement:        { _access:"all", view:"all", create:"all", edit:"all", delete:false, validate:"all", export:"all" },
    "reserves-quitus": { _access:"all", view:"all", create:"all", edit:"all", delete:false, validate:"all", export:"all" },
    gestionChantier:             { _access:"all", view:"all", create:"all", edit:"all", delete:false, validate:"all", export:"all" },
    "gestionChantier.pieuvres":  { _access:"all", view:"all" },
    "gestionChantier.commandes": { _access:"all", view:"all" },
    "gestionChantier.financier": { _access:"all", view:"all" },
    "gestionChantier.suivi":     { _access:"all", view:"all" },
    "gestionChantier.gantt":     { _access:"all", view:"all" },
    "gestionChantier.tma":       { _access:"all", view:"all" },
    "gestionChantier.demarches": { _access:"all", view:"all" },
    "gestionChantier.planning":  { _access:"all", view:"all" },
    rh:            { _access:"all", view:"all", create:"all", edit:"all", delete:false, validate:"all", export:"all" },
    "rh.planning": { _access:"all", view:"all" },
    "rh.conges":   { _access:"all", view:"all" },
    "rh.frais":    { _access:"all", view:"all" },
    "rh.analyse":  { _access:"all", view:"all" },
    _dashboards: { direction:true, conducteur:true, public:true },
    _admin: false,
  },
  "Conducteur travaux": {
    // v10.I — Fix 1 : delete autorisé sur ses chantiers (y compris statut
    // "Envoyée aux achats"). La règle métier "pas après Commandée" est dans
    // CommandesInner.canDeleteOrder().
    commandes:         { _access:"all", view:"own_chantiers", create:"all", edit:"own_items", delete:"own_chantiers", validate:"own_chantiers", export:"own_chantiers" },
    "parc-machines":   { _access:"all", view:"all", create:"all", edit:"own_chantiers", delete:false, export:"own_chantiers" },
    avancement:        { _access:"all", view:"own_chantiers", create:"own_chantiers", edit:"own_chantiers", delete:false, validate:"own_chantiers", export:"own_chantiers" },
    "reserves-quitus": { _access:"all", view:"own_chantiers", create:"own_chantiers", edit:"own_chantiers", delete:false, validate:"own_chantiers", export:"own_chantiers" },
    gestionChantier:             { _access:"all", view:"own_chantiers", create:"own_chantiers", edit:"own_chantiers", delete:false, validate:"own_chantiers", export:"own_chantiers" },
    "gestionChantier.pieuvres":  { _access:"all", view:"own_chantiers" },
    "gestionChantier.commandes": { _access:"all", view:"own_chantiers" },
    "gestionChantier.financier": { _access:"all", view:"own_chantiers" },
    "gestionChantier.suivi":     { _access:"all", view:"own_chantiers" },
    "gestionChantier.gantt":     { _access:"all", view:"own_chantiers" },
    "gestionChantier.tma":       { _access:"all", view:"own_chantiers" },
    "gestionChantier.demarches": { _access:"all", view:"own_chantiers" },
    "gestionChantier.planning":  { _access:"all", view:"own_chantiers" },
    rh:            { _access:"all", view:"own_chantiers", create:"own_chantiers", edit:"own_chantiers", delete:false, validate:"own_chantiers", export:"own_chantiers" },
    "rh.planning": { _access:"all", view:"own_chantiers" },
    _dashboards: { direction:false, conducteur:true, public:true },
    _admin: false,
  },
  Assistante: {
    commandes:         { _access:"all", view:"all", create:"all", edit:"all", delete:false, validate:false, export:"all" },
    "parc-machines":   { _access:"all", view:"all", create:"all", edit:"all", delete:false, export:"all" },
    avancement:        { _access:"all", view:"all", create:false, edit:false, delete:false, validate:false, export:"all" },
    "reserves-quitus": { _access:"all", view:"all", create:"all", edit:"all", delete:false, validate:false, export:"all" },
    gestionChantier:             { _access:"all", view:"all", create:"all", edit:"all", delete:false, validate:false, export:"all" },
    "gestionChantier.financier": { _access:"all", view:"all" },
    "gestionChantier.demarches": { _access:"all", view:"all" },
    "gestionChantier.planning":  { _access:"all", view:"all" },
    rh:            { _access:"all", view:"all", create:"all", edit:"all", delete:false, validate:false, export:"all" },
    "rh.planning": { _access:"all", view:"all" },
    "rh.conges":   { _access:"all", view:"all" },
    "rh.frais":    { _access:"all", view:"all" },
    "rh.analyse":  { _access:"all", view:"all" },
    _dashboards: { direction:false, conducteur:false, public:true },
    _admin: false,
  },
  // Rôle « Achat » — pilotage achats / dashboard achat@. Clés canoniques
  // (pas reserves/outillage/chantiers : ce sont des clés legacy de l'override
  // Firestore rolesConfig/Achat, qui reste inchangé et prioritaire par clé).
  Achat: {
    commandes:         { _access:"all", view:"all", create:"all", edit:"all", delete:"all", validate:"all", export:"all" },
    "parc-machines":   { _access:"all", view:"all", create:false, edit:false, delete:false, export:false },
    avancement:        { _access:"all", view:"all", create:false, edit:false, validate:false },
    "reserves-quitus": { _access:"all", view:"all", create:false, edit:false, delete:false, validate:false },
    gestionChantier:             { _access:"all", view:"all", create:false, edit:false, delete:false },
    "gestionChantier.pieuvres":  { _access:"all", view:"all" },
    "gestionChantier.commandes": { _access:"all", view:"all" },
    "gestionChantier.financier": { _access:"all", view:"all" },
    _dashboards: { conducteur: true },
    _admin: true,
  },
  "Chef chantier": {
    // v10.I — Fix 1 : delete autorisé sur ses chantiers.
    commandes:         { _access:"all", view:"own_chantiers", create:"all", edit:"own_items", delete:"own_chantiers", validate:false, export:false },
    "parc-machines":   { _access:"all", view:"own_chantiers", create:"own_chantiers", edit:"own_chantiers", delete:false, export:false },
    avancement:        { _access:"all", view:"own_chantiers", create:"own_chantiers", edit:"own_chantiers", delete:false, validate:false, export:false },
    "reserves-quitus": { _access:"all", view:"own_chantiers", create:"own_chantiers", edit:"own_chantiers", delete:false, validate:false, export:false },
    gestionChantier:             { _access:false },
    _dashboards: { direction:false, conducteur:false, public:true },
    _admin: false,
  },
  Monteur: {
    commandes:         { _access:"all", view:"own_items", create:"all", edit:"own_items", delete:false, validate:false, export:false },
    "parc-machines":   { _access:"all", view:"own_chantiers", create:false, edit:false, delete:false, export:false },
    avancement:        { _access:"all", view:"own_chantiers", create:"own_chantiers", edit:"own_items", delete:false, validate:false, export:false },
    "reserves-quitus": { _access:"all", view:"own_chantiers", create:"own_chantiers", edit:"own_items", delete:false, validate:false, export:false },
    gestionChantier:             { _access:false },
    rh:            { _access:"all", view:"own_items", create:false, edit:false, delete:false, validate:false, export:false },
    "rh.planning": { _access:"all", view:"own_items" },
    _dashboards: { direction:false, conducteur:false, public:true },
    _admin: false,
  },
  Artisan: {
    commandes:         { _access:false },
    "parc-machines":   { _access:false },
    avancement:        { _access:"all", view:"own_chantiers", create:false, edit:false, delete:false, validate:false, export:false },
    "reserves-quitus": { _access:"all", view:"own_chantiers", create:"own_chantiers", edit:"own_items", delete:false, validate:false, export:false },
    gestionChantier:             { _access:false },
    _dashboards: { direction:false, conducteur:false, public:false },
    _admin: false,
  },
  // Rôle « Étude » — bureau d'études (hors terrain). Lecture seule des modules
  // utiles ; EXCLU des frais de déplacement (liste blanche terrain côté
  // genererRecapFrais). Droits ouvrables au besoin via rolesConfig.
  "Étude": {
    commandes:         { _access:"all", view:"all", create:false, edit:false, delete:false, validate:false, export:false },
    avancement:        { _access:"all", view:"all", create:false, edit:false, delete:false, validate:false, export:false },
    "reserves-quitus": { _access:"all", view:"all", create:false, edit:false, delete:false, validate:false, export:false },
    gestionChantier:         { _access:"all", view:"all", create:false, edit:false, delete:false },
    "gestionChantier.tma":   { _access:"all", view:"all" },
    _dashboards: { direction:false, conducteur:false, public:true },
    _admin: false,
  },
};

// ─── Utilitaires ────────────────────────────────────────────────
const SCOPE_RANK = { "all":3, "own_chantiers":2, "own_items":1, false:0, undefined:0 };
function mostPermissive(a, b) {
  return (SCOPE_RANK[a] || 0) >= (SCOPE_RANK[b] || 0) ? a : b;
}

export function getRoles(user) {
  if (!user) return [];
  if (Array.isArray(user.roles) && user.roles.length > 0) return user.roles;
  if (user.role)    return [user.role];
  if (user.fonction) return [legacyRoleFromFonction(user.fonction)];
  return ["Monteur"];
}

// Fusionne FACTORY + override de rôle Firestore
export function getEffectiveRolePerms(roleName, rolesConfig) {
  const factory = DEFAULT_PERMISSIONS[roleName] || {};
  const override = rolesConfig?.[roleName] || null;
  if (!override) return factory;

  // Deep merge factory + override
  const merged = JSON.parse(JSON.stringify(factory));
  for (const key of Object.keys(override)) {
    const val = override[key];
    if (val === null || val === undefined) continue;
    if (typeof val === "object" && !Array.isArray(val)) {
      merged[key] = { ...(merged[key] || {}), ...val };
    } else {
      merged[key] = val;
    }
  }
  return merged;
}

// can() : résout les 3 couches, couche la plus spécifique gagne
export function can(user, module, action, rolesConfig = null) {
  if (!user) return false;

  const userRoles = getRoles(user);
  const userOverride = user.permissionsOverride || {};

  // ── _admin ──
  if (module === "_admin") {
    if (userOverride._admin !== undefined) return userOverride._admin;
    return userRoles.some(r => getEffectiveRolePerms(r, rolesConfig)._admin === true);
  }

  // ── _dashboards ──
  if (module === "_dashboards") {
    const ovDash = userOverride._dashboards || {};
    if (action in ovDash) return !!ovDash[action];
    return userRoles.some(r => getEffectiveRolePerms(r, rolesConfig)._dashboards?.[action] === true);
  }

  // ── Module métier : override user ? ──
  const ovModule = userOverride[module];
  if (ovModule === "all")   return "all";
  if (ovModule === false)   return false;
  if (ovModule && typeof ovModule === "object" && action in ovModule) {
    return ovModule[action];
  }

  // Cumul au + permissif parmi les rôles (après override de rôle DB)
  let bestScope = false;
  for (const role of userRoles) {
    const perms = getEffectiveRolePerms(role, rolesConfig);
    const mod = perms[module];
    if (!mod) continue;
    const scope = mod[action];
    if (scope === undefined) continue;
    bestScope = mostPermissive(bestScope, scope);
  }
  return bestScope;
}

export function legacyRoleFromFonction(fonction) {
  if (!fonction) return "Monteur";
  const f = fonction.toLowerCase();
  if (f.includes("admin"))      return "Admin";
  if (f.includes("direct"))     return "Direction";
  if (f.includes("conducteur")) return "Conducteur travaux";
  if (f.includes("assist"))     return "Assistante";
  if (f.includes("chef"))       return "Chef chantier";
  if (f.includes("artisan"))    return "Artisan";
  if (f.includes("étude") || f.includes("etude")) return "Étude";
  return "Monteur";
}

export function rolesLabel(user) {
  const roles = getRoles(user);
  if (roles.length === 0) return "—";
  if (roles.length === 1) return roles[0];
  if (roles.length === 2) return roles.join(" + ");
  return `${roles[0]} + ${roles.length - 1} autres`;
}

export function hasRoleOverride(roleName, rolesConfig) {
  return !!(rolesConfig?.[roleName]);
}
